import { Flex } from "antd";
import type { KeyboardEvent, ReactNode } from "react";
import styles from "./FilePreviewTrigger.module.css";

type FilePreviewTriggerProps = {
  onPreview: () => void;
  ariaLabel: string;
  className?: string;
  children: ReactNode;
};

export const FilePreviewTrigger = ({
  onPreview,
  ariaLabel,
  className,
  children,
}: FilePreviewTriggerProps) => {
  const openPreviewOnKeyboardActivation = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onPreview();
    }
  };

  return (
    <Flex
      align="center"
      gap={8}
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      className={`${styles.trigger} ${className ?? ""}`}
      onClick={onPreview}
      onKeyDown={openPreviewOnKeyboardActivation}
    >
      {children}
    </Flex>
  );
};
